module.exports = __webpack_public_path__ + "static/media/html.a637aa78.svg";